import { RootState } from '../../../../reducers'
import { StorageType } from '../../../../features/storages/types'
import { initialState, StoragesSliceState } from './slice'

const storagesSliceSelector = (state: RootState): StoragesSliceState => {
  return state.dock?.sections?.storages ?? initialState
}

export function scrollTopPxSelector(state: RootState): number {
  return storagesSliceSelector(state)?.scrollTopPx
}

export function visibleStorageTypesSelector(state: RootState): StorageType[] {
  return storagesSliceSelector(state)?.visibleTypes
}

export function storageSearchQuerySelector(state: RootState): string {
  return storagesSliceSelector(state)?.searchQuery || ''
}
